<div fxLayout="column" fxLayoutGap="20px" class="layout-padd" fxLayoutAlign="center center" [ngStyle]="{'max-height.px': innerHeight}" fxFlexFill>

    <div fxLayout="row" fxLayoutAlign="center center" class="layout-padd full-w">
        <mat-icon color="primary" style="font-size: 3em;">location_city</mat-icon>
    </div>

    <div fxLayoutGap="10px">

        <div fxLayoutAlign="center center" class="text-center layout-padd">
            <span class="mat-subheading">
                {{'alertinvalidcityComponent.noEligibity'|translate}}</span>
        </div>

        <div fxLayoutAlign="center center" fxLayoutGap="5px">

            <div>
                <span class="mat-headline warn-ico">{{delivryAddress.city_name | uppercase}}</span>
            </div>

            <div>
                <i class="material-icons primary-ico icon-info clicked" angulartics2On="click" angularticsAction="openEligibleCitiesDial" angularticsCategory="order" matTooltip="{{'tooltip.listElig'|translate}}" (click)="openEligibleCitiesDial()">info</i>
            </div>

        </div>

    </div>

    <button mat-stroked-button class="full-w dark-ico" (click)="closeDial()" angulartics2On="click" angularticsAction="closeMaxWeightDial" angularticsCategory="order">
    <span class="mat-title">{{"dialogs.go-back" | translate}}</span>
  </button>

</div>